
























































































































































































































































































import moment from 'moment';

import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';

import Functions from '@/mixins/functions';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';
import Snackbar from '@/mixins/snackbar';

import {
  IVacationCarryOverRequest,
  IVacationCarryOverRequestData,
  IUserData,
  VacationCarryOverRequestStateEnum,
  IEmployee,
  VacationCarryOverRequest
} from '@/models';
import { IUpdateVacationCarryOverStatePayload } from '@/store/vacation-carry-over-request';

import { merge, omit } from 'lodash';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import VacationCarryOverRequestFormDialog from '@/components/vacation-carry-over-request/VacationCarryOverRequestFormDialog.vue';
import VacationCarryOverRequestDetailDialog from '@/components/vacation-carry-over-request/VacationCarryOverRequestDetailDialog.vue';
import VacationCarryOverRequestSearchFilter from '@/components/vacation-carry-over-request/VacationCarryOverRequestSearchFilter.vue';
import VacationCarryOverRequestActivityDialog from '@/components/vacation-carry-over-request/VacationCarryOverRequestActivityDialog.vue';
import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';

import ALPage from '@/components/core/Page/ALPage.vue';
import { IFetchVacationCarryOverRequestsFilterParams } from '@/services';

const baseMixins = mixins(Functions, auth, Snackbar);

interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    vacationCarryOverRequestFormDialog: InstanceType<
      typeof VacationCarryOverRequestFormDialog
    >;
    carryOverRequestActivityDialog: InstanceType<
      typeof VacationCarryOverRequestActivityDialog
    >;
  };
}

export default baseMixins
  .extend<Options>({ functional: false })
  .extend({
    components: {
      ConfirmationDialog,
      ErrorAlert,
      VacationCarryOverRequestFormDialog,
      VacationCarryOverRequestDetailDialog,
      VacationCarryOverRequestSearchFilter,
      VacationCarryOverRequestActivityDialog,
      ALPage
    },
    data() {
      return {
        loading: false,
        detailDialog: false,

        isSearchFilterActive: false,

        selectedVacationCarryOver: {} as IVacationCarryOverRequestData,

        params: {
          search: '',
          page: 1
        } as IFetchVacationCarryOverRequestsFilterParams,

        sortBy: 'id',
        sortDesc: true,

        errorMessage: '',
        detailErrorMessage: '',

        headers: [
          {
            text: 'ID',
            sortable: false,
            value: 'id',
            width: 50
          },
          {
            text: 'Employee',
            sortable: false,
            value: 'employee',
            width: 250
          },
          {
            text: 'Year',
            sortable: false,
            value: 'year',
            width: 100
          },
          {
            text: 'Amount Requested (Days)',
            sortable: false,
            align: 'center',
            value: 'amount_requested',
            width: 250
          },
          {
            text: 'Approver',
            sortable: false,
            value: 'approvers',
            width: 200
          },
          {
            text: 'Last Modified',
            sortable: false,
            value: 'updated_at',
            width: 250
          },
          {
            text: 'Status',
            sortable: false,
            align: 'center',
            value: 'state',
            width: 200
          },
          {
            text: '',
            sortable: false,
            align: 'center',
            value: 'actions',
            width: 100
          }
        ],

        VacationCarryOverRequestStateEnum,
        cancelConfirmationDialog: false,

        requestDetailQueryParam: this.$route.query.request,

        //comments
        commentsDialog: false,

        vacationCarryOverComment: '',
        actionLabel: '',

        commentErrorMessage: '',
        commentErrorMessageDetail: '',

        state: VacationCarryOverRequestStateEnum.Draft
      };
    },

    computed: {
      ...mapGetters({
        vacationCarryOverRequests:
          'vacationCarryOverRequest/getVacationCarryOverRequests',
        getVacationCarryOverRequestById:
          'vacationCarryOverRequest/getVacationCarryOverRequestById',
        numCarryOvers: 'vacationCarryOverRequest/getVacationCarryOverCount'
      }),

      isVacationCarryOverApprover(): boolean {
        const approverVacationCarryOver = this.vacationCarryOverRequests.filter(
          (vacationCarryOver: IVacationCarryOverRequest) => {
            return vacationCarryOver
              .approvers!.map(approver => (approver.approver as IUserData).id)
              .includes(this.currentUser.id);
          }
        );
        return approverVacationCarryOver;
      },

      extraFiltersApplied(): boolean {
        return Object.keys(omit(this.$route.query, ['page', 'search'])).some(
          v => !!v
        );
      }
    },

    watch: {
      'params.search'(search: string) {
        this.debounceFetchVacationCarryOverRequests({
          ...this.params,
          search: search,
          page: 1
        }).then(() => {
          this.params.page = 1;
        });
      }
    },

    async mounted() {
      // update `this.params` from the route query object.
      // omitting `search` and `page` as they are already set in the data vue option
      merge(this.params, omit(this.$route.query, ['page', 'search']));

      this.loading = true;
      this.searchVacationCarryOverRequests(this.params);

      if (this.requestDetailQueryParam) {
        const vacationCarryOver = await this.tryGetOrFetchVacationCarryOverRequest(
          Number(this.requestDetailQueryParam)
        ).catch(() => {
          this.clearVacationCarryOverDetailQueryParam();
          this.createSnack({
            color: 'error darken-1',
            type: 'error',
            right: true,
            useBtn: false,
            msg: `Error retrieving vacation carry-over request`,
            btnText: 'Ok',
            timeout: 6000
          });
          return;
        });

        if (vacationCarryOver) {
          this.openVacationCarryOverDetailDialog(vacationCarryOver);
        }
      }
    },

    methods: {
      moment,

      ...mapActions({
        fetchVacationCarryOverRequests:
          'vacationCarryOverRequest/fetchVacationCarryOverRequests',
        fetchVacationCarryOverRequest:
          'vacationCarryOverRequest/fetchVacationCarryOverRequest',
        updateVacationCarryOverRequestState:
          'vacationCarryOverRequest/updateVacationCarryOverRequestState'
      }),

      openActivitesDialog(request: IVacationCarryOverRequest) {
        this.$refs.carryOverRequestActivityDialog.open(request);
      },

      async tryGetOrFetchVacationCarryOverRequest(
        vacationCarryOverId: number
      ): Promise<IVacationCarryOverRequest | undefined> {
        if (!this.getVacationCarryOverRequestById(vacationCarryOverId)) {
          await this.fetchVacationCarryOverRequest(vacationCarryOverId);
        }

        return this.getVacationCarryOverRequestById(vacationCarryOverId);
      },

      clearAllErrors(): void {
        this.errorMessage = '';
        this.detailErrorMessage = '';
        this.commentErrorMessage = '';
        this.commentErrorMessageDetail = '';
      },

      close() {
        this.detailDialog = false;
      },

      // Owner of the personal request can edit anytime when in submitted state.
      canEdit(request: IVacationCarryOverRequestData): boolean {
        return (
          this.isUserOwner(request) &&
          request.state == VacationCarryOverRequestStateEnum.Submitted
        );
      },

      isUserOwner(request: IVacationCarryOverRequestData): boolean {
        return (request.employee as IEmployee).id == this.currentUser.employee;
      },

      isUserApprover(request: IVacationCarryOverRequestData): boolean {
        return request.approvers.some(
          approver => (approver.approver as IUserData).id == this.currentUser.id
        );
      },

      canRejectOrApproveState(request: IVacationCarryOverRequestData): boolean {
        return (
          this.isUserApprover(request) &&
          request.state == VacationCarryOverRequestStateEnum.Submitted
        );
      },

      // Owner of the personal request can cancel anytime when in submitted state.
      // Once approved, only manager can cancel
      // If user is approver or SA they can cancel when not rejected or cancelled
      canCancel(request: IVacationCarryOverRequestData): boolean {
        let canCancel = false;

        if (this.isUserOwner(request)) {
          canCancel =
            request.state == VacationCarryOverRequestStateEnum.Submitted;
        } else if (
          request.state == VacationCarryOverRequestStateEnum.Approved &&
          (this.isUserApprover(request) || this.isUserHRPersonnel)
        ) {
          canCancel = true;
        }
        return canCancel;
      },

      openVacationCarryOverDetailDialog(
        vacationCarryOver: IVacationCarryOverRequest
      ) {
        this.selectedVacationCarryOver = vacationCarryOver;
        this.detailDialog = true;
      },

      openVacationCarryOverRequestDialog(
        vacationCarryOver?: IVacationCarryOverRequestData
      ) {
        this.$refs.vacationCarryOverRequestFormDialog.open(vacationCarryOver);
      },

      async debounceFetchVacationCarryOverRequests(
        params: IFetchVacationCarryOverRequestsFilterParams
      ) {
        this.clearAllErrors();
        this.loading = true;

        return await this.debounce(
          this.searchVacationCarryOverRequests,
          200
        )(params);
      },

      searchVacationCarryOverRequests(
        params: IFetchVacationCarryOverRequestsFilterParams
      ) {
        /* this will update the URL query based on param values. */
        this.$router
          .replace({
            name: 'vacation-carry-over-request-list',
            query: params as Record<string, any>
          })
          .catch((e: Error) => e); //catch navigation duplication error

        return this.fetchVacationCarryOverRequests(params)
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
            if (error.response) {
              if (error.response.data.detail) {
                this.detailErrorMessage = error.response.data.detail;
              }
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },

      refreshSearchFilter(params: IFetchVacationCarryOverRequestsFilterParams) {
        this.clearAllErrors();

        this.loading = true;
        this.searchVacationCarryOverRequests({
          page: this.params.page,
          search: this.params.search,
          ...params
        }).then(() => {
          // update params objects
          this.params.page = params.page;
          this.params.state = params.state;

          this.params.page = 1;
        });
      },

      onUpdatePage(newPage: number) {
        if (newPage != this.params.page) {
          this.searchVacationCarryOverRequests({
            ...this.params,
            page: newPage
          }).then(() => {
            this.params.page = newPage;
          });
        }
      },

      openCommentDialog(
        request: IVacationCarryOverRequest,
        state: VacationCarryOverRequestStateEnum
      ) {
        this.selectedVacationCarryOver = request;
        this.vacationCarryOverComment = ''; //clears comment dialog on open
        this.commentsDialog = true;
        this.actionLabel = VacationCarryOverRequestStateEnum[state];
        this.state = state;
      },

      closeCommentsDialog() {
        this.clearAllErrors();
        this.commentsDialog = false;
      },

      setVacationCarryOverState() {
        this.loading = true;

        const payload = {
          id: this.selectedVacationCarryOver.id,
          state: this.state,
          comment: this.vacationCarryOverComment
        } as IUpdateVacationCarryOverStatePayload;

        this.updateVacationCarryOverRequestState(payload)
          .then(data => {
            this.close();
            this.closeCommentsDialog();
            const stateInfo = new VacationCarryOverRequest({
              ...(this
                .selectedVacationCarryOver as IVacationCarryOverRequestData),
              state: payload.state
            }).getStateInfo();

            this.createSnack({
              color: `${stateInfo.color} darken-1`,
              type: `${stateInfo.color}`,
              right: true,
              useBtn: false,
              msg: `Carry-Over Request ${stateInfo.display_name}`,
              btnText: 'Ok',
              timeout: 6000
            });

            this.$emit('rebuild');
          })
          .catch(error => {
            if (error.response) {
              if (error.response.data.detail) {
                this.commentErrorMessageDetail = error.response.data.detail;
              }
            }
            this.commentErrorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      clearVacationCarryOverDetailQueryParam() {
        // clear the detail query in route
        this.$router
          .replace({
            name: 'vacation-carry-over-request-list'
          })
          .catch((e: Error) => e);
      }
    }
  });
